import { Row, Col, Typography, Space, Grid } from 'antd';
import { ExportButton } from './ExportButton';
import type { ExportButtonProps } from './ExportButton';

const { Title } = Typography;
const { useBreakpoint } = Grid;

export type PageHeaderExportConfig = ExportButtonProps;

type PageHeaderProps = {
  title: string;
  actions?: React.ReactNode;
  exportConfig?: PageHeaderExportConfig;
};

const PageHeader = ({ title, actions, exportConfig }: PageHeaderProps) => {
  const screens = useBreakpoint();
  // Stack title and actions vertically below `sm` breakpoint (576px). At that
  // width and above, render them on a single row.
  const stackVertically = !screens.sm;

  const hasRightContent = !!exportConfig || !!actions;

  // Single source of truth for the actions block so we render it identically
  // in both layouts.
  const actionsBlock = hasRightContent ? (
    <div className="page-header-actions">
      <Space size="small" wrap>
        {exportConfig && <ExportButton {...exportConfig} />}
        {actions}
      </Space>
    </div>
  ) : null;

  if (stackVertically) {
    return (
      <div
        className="page-header-row"
        style={{ marginBottom: 16, display: 'flex', flexDirection: 'column', gap: 8 }}
      >
        <Title level={4} style={{ margin: 0 }} ellipsis={{ tooltip: title }}>
          {title}
        </Title>
        {actionsBlock}
      </div>
    );
  }

  return (
    <Row
      justify="space-between"
      align="middle"
      wrap={false}
      gutter={16}
      style={{ marginBottom: 16 }}
      className="page-header-row"
    >
      <Col flex="auto" style={{ minWidth: 0 }}>
        <Title level={4} style={{ margin: 0 }} ellipsis={{ tooltip: title }}>
          {title}
        </Title>
      </Col>
      {actionsBlock && <Col flex="none">{actionsBlock}</Col>}
    </Row>
  );
};

export default PageHeader;
